export default "__VITE_ASSET__DQW3$Tyn__"